/* titanore-hero-autoplay 20260822 — keep homepage + GEM hero loops playing */
(function () {
  var SEL = 'video[data-tl-hero-autoplay], video[data-tgem-hero-video]';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isVisible(vid) {
    if (!vid || !vid.isConnected) return false;
    var rect = vid.getBoundingClientRect();
    if (rect.width < 2 || rect.height < 2) return false;
    var style = window.getComputedStyle(vid);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0.01;
  }

  function prep(vid) {
    if (!vid || vid.__tlHeroAutoplayPrep) return;
    vid.__tlHeroAutoplayPrep = true;
    vid.muted = true;
    vid.defaultMuted = true;
    vid.setAttribute('muted', '');
    vid.setAttribute('playsinline', '');
    vid.setAttribute('webkit-playsinline', '');
    if (!vid.getAttribute('autoplay')) vid.setAttribute('autoplay', '');
    if (!vid.getAttribute('preload') || vid.getAttribute('preload') === 'metadata') {
      vid.setAttribute('preload', 'auto');
    }
  }

  function tryPlay(vid) {
    if (!vid || !isVisible(vid) || reducedMotion()) return;
    prep(vid);
    var playPromise = vid.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        setTimeout(function () {
          if (isVisible(vid) && !vid.paused) return;
          vid.play().catch(function () {});
        }, 400);
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll(SEL).forEach(tryPlay);
  }

  window.__tlResumeHeroAutoplay = function () {
    boot();
  };

  if (!window.__tlHeroAutoplayTick) {
    window.__tlHeroAutoplayTick = setInterval(function () {
      if (reducedMotion() || document.hidden) return;
      document.querySelectorAll(SEL).forEach(function (vid) {
        if (isVisible(vid) && vid.paused) tryPlay(vid);
      });
    }, 2000);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) boot();
  });
  window.addEventListener('pageshow', function () {
    boot();
  });
  document.body && document.body.addEventListener('modalClosed', function () {
    setTimeout(boot, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }
  setTimeout(boot, 250);
  setTimeout(boot, 900);
  setTimeout(boot, 2200);
})();
